interface MaskAspectRatioShape {
  width?: number | null
  height?: number | null
  svgContent?: string | null
}

// svgContent's viewBox is the authoritative size for extracted mask shapes
// (see parse-svg-view-box-size) since their stored width/height can be wrong.
export const useMaskAspectRatio = (maskShape: MaskAspectRatioShape | undefined): string | undefined => {
  if (maskShape?.svgContent) {
    const size = parseSvgViewBoxSize(maskShape.svgContent)
    if (size) return `${size.width} / ${size.height}`
  }

  return maskShape?.width && maskShape?.height ? `${maskShape.width} / ${maskShape.height}` : undefined
}
